import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";
import { noop } from "@client/shared/constants";
import config from "@client/config";
import { jwksApi } from "../../../shared/services/api-communicator";

// const RC_PRODUCTION_URL = config.rcApiBaseUrl.includes('devtest')
//   ? 'https://platform.ringcentral.com/restapi/v1.0'
//   : config.rcApiBaseUrl;

const RC_PRODUCTION_URL = config.rcApiBaseUrl;

const getCountryListUrl = "/dictionary/country";

const getCountryList = () => {
  return responseFormatter.rc(
    http.rc.get(`${getCountryListUrl}?perPage=1000`, {
      setAuthHeader: true,
    }),
  );
};

const getUser = (accountId = "") => {
  return responseFormatter.rc(
    http.rc.get(`/account/${accountId}/extension?type=User&perPage=1000`, {
      setAuthHeader: true,
    }),
  );
};

const parsePhoneNumber = (data) => {
  return responseFormatter.rc(
    http.rc.post(`/number-parser/parse`, data, {
      setAuthHeader: true,
    }),
  );
};

const getAllTeams = (accountId = "") => {
  return responseFormatter.rc(
    http.rc.get(`/glip/teams?recordCount=250`, {
      setAuthHeader: true,
    }),
  );
};

const getTimezoneList = async (token) => {
  return responseFormatter.rc(
    http.rc.get(`/dictionary/timezone?perPage=1000`, {
      setAuthHeader: true,
    }),
  );
};
const createTeam = async (data) => {
  return responseFormatter.rc(
    http.rc.post(`/glip/teams`, data, {
      setAuthHeader: true,
    }),
  );
};

const getExtensions = async (
  accountUid = "~",
  query = "",
  rateLimitReachedCallback = noop,
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/extension?perPage=1000`;
  return new Promise(async (resolve) => {
    const extensions = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } },
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      extensions.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            }),
          );
          error ? resolve({ data: null, error }) : extensions.push(...data);
        }
      }
      resolve({ data: extensions, error: null });
    }
  });
};

const getSmsFromNumbers = () => {
  return responseFormatter(
    http.get(`/sms-from-numbers`, {
      setAuthHeader: true,
    }),
  );
};

const Service = {
  getCountryList,
  getUser,
  getAllTeams,
  parsePhoneNumber,
  getTimezoneList,
  getExtensions,
  createTeam,
  getSmsFromNumbers,
};

export default Service;
